export default {
  defaultCenter: {
    lat: 23.3266,
    lng: -105.54305562247826,
  },
  zoom: 17,
  streetViewControl: false,
  fullscreenControl: false,
};
